module.exports = {"id":"209781","name":"Pierrick Capelle","rating":"75","photo":"./data/images/photos/4/209781.png","club":{"name":"Angers SCO","logo":"./data/images/clubs/AngersSCO.png"},"positions":["MC","AD","MG","AG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PierrickCapelle0.json
// module id = 3465
// module chunks = 0